export enum NavigationType {
  Horizontal = 1,
  Vertical = 2,
  None = 3
}
